export const projectConstants = {
  GET_PROJECT_REQUEST: 'GET_PROJECTS_REQUEST',
  GET_PROJECT_SUCCESS: 'GET_PROJECTS_SUCCESS',
  GET_PROJECT_FAILURE: 'GET_PROJECTS_FAILURE',
};

export const mailConstants = {
  SEND_MAIL_REQUEST: 'SEND_MAIL_REQUEST',
  SEND_MAIL_SUCCESS: 'SEND_MAIL_SUCCESS',
  SEND_MAIL_FAILURE: 'SEND_MAIL_FAILURE',
};
